/**
 * One build, two sites (site.ts): the address picks the Focal Point Care landing page or
 * the FCC portal. Each is loaded on its own, with its own styles, so neither reaches the
 * other, and the landing page loads no sign-in at all.
 */
import { createRoot } from 'react-dom/client'
import { fccRedirect, siteFor } from './site'

const away = fccRedirect(window.location)
if (away) window.location.replace(away)
else {
  const root = createRoot(document.getElementById('root')!)
  if (siteFor(window.location, import.meta.env.DEV) === 'landing') void import('./landing/main').then((m) => m.render(root))
  else void import('./portalMain').then((m) => m.render(root))
}
